export const TABLET_VIEW = 1024
export const PHONE_VIEW = 667

